<template>
  <pageHeader :pageName="this.$store.getters.getWordLocale('ÜRÜNLER')" />
  <div class="container">
    <div class="row">
      <div
        v-show="hasFilterItems"
        v-bind:class="{
          'col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12': true,
          'filters-box-control': true,
          show: showFilters,
        }"
      >
        <div class="filters-box">
          <div class="d-flex justify-content-between align-items-center">
            <span>{{
              this.$store.getters.getWordLocale("txt_filterleme")
            }}</span>
            <a
              v-on:click="toggleFilters"
              class="
                mobile-filtre-close
                d-xl-none d-lg-none d-md-inline-flex d-inline-flex
              "
              href="javascript:;"
            >
              <i class="material-icons-outlined">close </i>
            </a>
          </div>
          <div v-show="hasKeywords" class="did-floating-label-content">
            <input
              class="did-floating-input form-control"
              v-on:keyup.enter="getCompaniesList(0)"
              v-model="searchText"
              type="text"
              :placeholder="this.$store.getters.getWordLocale('txt_ara')"
            />
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_ara")
            }}</label>
          </div>

          <div class="did-floating-label-content">
            <select
              @change="setSelectedSearchCondition($event.target.value)"
              class="did-floating-select form-control"
              v-model="selectedMatchingCondition"
            >
              <option value="0">
                {{ this.$store.getters.getWordLocale("txt_seciniz") }}
              </option>

              <option value="1">
                {{ this.$store.getters.getWordLocale("txt_eslesen") }}
              </option>

              <option value="2">
                {{ this.$store.getters.getWordLocale("txt_icinde_gecen") }}
              </option>

              <option value="3" selected>
                {{ this.$store.getters.getWordLocale("txt_baslayan") }}
              </option>

              <option value="4">
                {{ this.$store.getters.getWordLocale("txt_biten") }}
              </option>
            </select>
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_eslestirme")
            }}</label>
          </div>

          <div v-show="hasCategory" class="did-floating-label-content">
            <select
              @change="setSelectedMainCategory($event.target.value)"
              class="did-floating-select form-control"
              v-model="selectedMainCategory"
            >
              <option value="0" selected>
                {{ this.$store.getters.getWordLocale("txt_tumu") }}
              </option>
              <option
                v-for="(cat, pIndex) in mainCategories"
                :key="pIndex"
                :value="cat.id"
              >
                {{ cat.text }}
              </option>
            </select>
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_kategori")
            }}</label>
          </div>
          <div
            v-show="selectedMainCategory > 0"
            class="did-floating-label-content did-error-input"
          >
            <select
              @change="setSelectedSubCategory($event.target.value)"
              class="did-floating-select form-control"
              v-model="selectedSubCategory"
            >
              <option value="0" selected>
                {{ this.$store.getters.getWordLocale("txt_tumu") }}
              </option>
              <option
                v-for="(cat, pIndex) in subCategories"
                :key="pIndex"
                :value="cat.id"
              >
                {{ cat.text }}
              </option>
            </select>
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_alt_katrgori")
            }}</label>
          </div>

          <div
            v-show="hasCountry"
            class="did-floating-label-content did-error-input"
          >
            <select
              @change="setSelectedCountry($event.target.value)"
              class="did-floating-select form-control"
              v-model="selectedCountry"
            >
              <option value="0" selected>
                {{ this.$store.getters.getWordLocale("txt_tumu") }}
              </option>
              <option
                v-for="(country, pIndex) in countries"
                :key="pIndex"
                :value="country.id"
              >
                {{ country.text }}
              </option>
            </select>
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_ulke")
            }}</label>
          </div>

          <div v-show="hasSegments" class="did-floating-label-content">
            <select
              class="did-floating-select form-control"
              @change="setSelectedBusinessSegment($event.target.value)"
              v-model="selectedBusinessSegment"
            >
              <option value="0" selected>
                {{ this.$store.getters.getWordLocale("txt_tumu") }}
              </option>
              <option
                v-for="(segment, index) in businessSegments"
                :key="index"
                :value="segment.value"
              >
                {{ segment.label }}
              </option>
            </select>
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_faaliyet_alanlari")
            }}</label>
          </div>

          <div class="did-floating-label-content did-error-input">
            <select
              class="did-floating-select form-control"
              @change="setSortByValue($event.target.value)"
              v-model="sortBy"
            >
              <option value="1">
                {{ this.$store.getters.getWordLocale("txt_akilli_siralama") }}
              </option>
              <option value="4">
                {{ this.$store.getters.getWordLocale("txt_alfabe_siralama") }}
              </option>
              <!-- <option value="5">
                {{ this.$store.getters.getWordLocale("txt_alfabe_siralama_z_a") }}
              </option> -->
              <option value="2">
                {{ this.$store.getters.getWordLocale("txt_ilk_yeniler") }}
              </option>
              <option value="3">
                {{ this.$store.getters.getWordLocale("txt_ilk_eskiler") }}
              </option>
            </select>
            <label class="did-floating-label">{{
              this.$store.getters.getWordLocale("txt_siralama")
            }}</label>
          </div>
          <div class="d-flex justify-content-between">
            <a
              v-on:click="clearFilters"
              class="btn btn-reset-filters"
              href="javascript:;"
              >{{ this.$store.getters.getWordLocale("txt_sifirla") }}</a
            >
            <a
              v-on:click="getCompaniesList(0)"
              class="btn apply-btn"
              href="javascript:;"
              >{{ this.$store.getters.getWordLocale("txt_uygula") }}</a
            >
          </div>
        </div>
      </div>
      <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12">
        <a
          v-on:click="toggleFilters"
          class="
            d-xl-none d-lg-none d-md-inline-flex d-inline-flex
            btn
            filtre-btn
          "
          ><i class="material-icons-outlined">filter_alt</i> Advanced Filter</a
        >

        <div class="product-list">
          <ForieLoader
            class="c-loader"
            v-show="showLoader && this.$store.state.domainSystemX == 1"
          />
          <TeLoader
            class="c-loader"
            v-show="showLoader && this.$store.state.domainSystemX == 2"
          />

          <div
            class="text-center alert alert-warning"
            v-show="companiesListData.length == 0 && showLoader == false"
          >
            <i class="fa fa-info-circle"></i>
            {{
              this.$store.getters.getWordLocale(
                "txt_aradiginiz_urun_bulunamadi"
              )
            }}
          </div>

          <div
            class="product-item"
            v-for="(company, index) in companiesListData"
            :key="index"
          >
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="d-flex flex-column item-description">
                  <div class="d-flex justify-content-between">
                    <a class="d-flex align-items-center">
                      <country-flag
                        :country="company.countryCode"
                        size="normal"
                      />
                      <span>{{ company.countryName }}</span></a
                    >
                  </div>

                  <router-link
                    :companyId="company.id"
                    :to="
                      '/' +
                      this.$store.state.langCodeX +
                      '/company/' +
                      company.link
                    "
                  >
                    <WordHighlighter
                      :query="this.$store.state.searchInputValueX"
                    >
                      {{ company.name }}
                    </WordHighlighter>
                  </router-link>

                  <p>
                    <WordHighlighter
                      :query="this.$store.state.searchInputValueX"
                      v-html="company.description"
                    >
                    </WordHighlighter>
                  </p>
                  <div v-show="company.products.length == 0" class="alert">
                    <i class="fa fa-info-circle"></i> Firmanın ürün bilgileri
                    güncellenmemiştir. Biraz sonra kontrol ediniz.
                  </div>

                  <lightgallery
                    :settings="{ speed: 500, plugins: plugins }"
                    :onInit="onInit"
                    :onBeforeSlide="onBeforeSlide"
                    class="product-list-light-gallary-area"
                  >
                    <router-link
                      v-for="(product, index) in company.products"
                      :key="index"
                      :to="
                        '/' +
                        this.$store.state.langCodeX +
                        '/' +
                        product.productLink +
                        '/' +
                        product.companyUrlName
                          .split(`-`)
                          .slice(0, 3)
                          .join(`-`) +
                        '-' +
                        product.companyId +
                        '/' +
                        product.countryName.toLowerCase().split(' ')[0] +
                        '/export-products'
                      "
                      class="gallery-item"
                      :data-src="
                        'https://cdn.turkishexporter.com.tr' + product.image
                      "
                    >
                      <img
                        class="img-responsive"
                        :title="product.fullTitle"
                        :src="
                          'https://cdn.turkishexporter.com.tr' + product.image
                        "
                        @error="setInvalidImage"
                        :alt="product.title"
                      />
                      <small :title="product.fullTitle"
                        >{{ product.title }}
                      </small>
                    </router-link>
                  </lightgallery>
                  <div class="d-flex item-extra-description">
                    <a
                      v-show="
                        companiesMembershipDetails.filter(
                          (q) => q.companyId == company.id
                        )[0] != undefined
                      "
                    >
                      <img
                        v-show="
                          companiesMembershipDetails.filter(
                            (q) =>
                              q.companyId == company.id &&
                              q.logo != '' &&
                              q.logo != undefined
                          )[0] != undefined
                        "
                        :src="
                          companiesMembershipDetails.filter(
                            (q) =>
                              q.companyId == company.id &&
                              q.logo != '' &&
                              q.logo != undefined
                          )[0] != undefined
                            ? 'http://cdn.forie.com' +
                              companiesMembershipDetails.filter(
                                (q) =>
                                  q.companyId == company.id &&
                                  q.logo != '' &&
                                  q.logo != undefined
                              )[0].logo
                            : require(`/src/assets/img/premium.svg`)
                        "
                      /><span>{{
                        companiesMembershipDetails.filter(
                          (q) => q.companyId == company.id
                        )[0] == undefined
                          ? ""
                          : companiesMembershipDetails.filter(
                              (q) => q.companyId == company.id
                            )[0].name.replace("TCOIN","")
                      }}</span></a
                    >
                    <a v-show="company.isVip">
                      <img :src="require(`/src/assets/img/VIP.svg`)" />
                      <span>{{
                        this.$store.getters.getWordLocale("txt_vip_uye")
                      }}</span></a
                    >
                    <a v-show="company.years != ''">
                      <img :src="require(`/src/assets/img/Years.svg`)" /><span
                        >{{ company.years }} Years</span
                      ></a
                    >
                    <div class="company-keywords d-flex">
                      <WordHighlighter
                        v-for="(keyword, kIndex) in company.keywords.slice(
                          0,
                          5
                        )"
                        :key="kIndex"
                        :query="this.$store.state.searchInputValueX"
                      >
                        <span>{{ keyword }}</span>
                      </WordHighlighter>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="height: 70px" v-show="currentPage > 0 && showMoreLoader">
            <ForieLoader
              class="more-svg"
              v-show="this.$store.state.domainSystemX == 1"
            />
            <TeLoader
              class="more-svg"
              v-show="this.$store.state.domainSystemX == 2"
            />
          </div>

          <div
            v-show="noMoreCompanies == false && companiesListData.length > 0"
          >
            <div class="d-flex justify-content-center more-company-box mb-4">
              <a
                v-on:click="getCompaniesList(currentPage + 1)"
                href="javascript:;"
                class="btn btn-large-primary-button mt-2"
                >{{
                  this.$store.getters.getWordLocale("txt_daha_fazla_yukle")
                }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
</style>
<style lang="postcss">
.product-list-light-gallary-area {
  display: flex;
  flex-wrap: wrap;
  margin-top: 21px;
}

.product-list-light-gallary-area > a {
  width: 151px;
  display: inline-flex;
  margin-right: 16px;
  flex-direction: column;
  justify-content: space-between;
  background: var(--m3--read-only--light--outline--opacity-008);
  /* M3/read-only/light/outline/opacity-0.08 */
  border: 1px solid var(--m3--read-only--light--outline--opacity-008);
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 21px;
  cursor: pointer;
}

.product-list-light-gallary-area > a:last-child {
  margin-right: 0;
}

.product-list-light-gallary-area > a > img {
  width: 100%;
  max-height: 150px;
}
.product-list-light-gallary-area > a > small {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */
  letter-spacing: 0.5px;
  /* M3/sys/light/on-surface */
  color: var(--m3--sys--light--on-surface);
  padding: 16px;
}
.did-floating-label-content {
  position: relative;
  margin-bottom: 20px;
}
.did-floating-label {
  color: #1e4c82;
  font-size: 13px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 15px;
  top: 20px;
  padding: 0 5px;
  background: var(--m3--sys--light--on-primary);
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.did-floating-input,
.did-floating-select {
  font-size: 12px;
  display: block;
  width: 100%;
  height: 56px;
  padding: 0 20px;
  background: var(--m3--sys--light--on-primary);
  border-radius: 4px;
  box-sizing: border-box;

  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  letter-spacing: 0.5px;

  /* M3/sys/light/on-surface */
  color: var(--m3--sys--light--on-surface-variant);
}
.did-floating-input:focus,
.did-floating-select:focus {
  outline: none;
  box-shadow: none !important;
}
.did-floating-input:focus ~ .did-floating-label,
.did-floating-select:focus ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}
select.did-floating-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
select.did-floating-select::-ms-expand {
  display: none;
}
.did-floating-input:not(:placeholder-shown) ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}
.did-floating-select:not([value=""]):valid ~ .did-floating-label {
  top: -8px;
  font-size: 13px;
}
.did-floating-select[value=""]:focus ~ .did-floating-label {
  top: 20px;
  font-size: 13px;
}
.did-floating-select:not([multiple]):not([size]) {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%23003d71'/%3E%3C/svg%3E%0A");
  background-position: right 15px top 50%;
  background-repeat: no-repeat;
}
/* .did-error-input .did-floating-input, .did-error-input .did-floating-select {
  border: 2px solid #9d3b3b;
  color: #9d3b3b;
}
.did-error-input .did-floating-label {
  font-weight: 600;
  color: #9d3b3b;
}
.did-error-input .did-floating-select:not([multiple]):not([size]) {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%239d3b3b'/%3E%3C/svg%3E%0A");
} */
.input-group {
  display: flex;
}
.input-group .did-floating-input {
  border-radius: 0 4px 4px 0;
  border-left: 0;
  padding-left: 0;
}
.input-group-append {
  display: flex;
  align-items: center;
  /*   margin-left:-1px; */
}
.input-group-text {
  display: flex;
  align-items: center;
  font-weight: 400;
  height: 34px;
  padding: 0 5px 0 20px;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
  border-radius: 4px 0 0 4px;
  border-right: none;
}
option {
  /* M3/read-only/light/surface2 */
  background: var(--m3--read-only--light--surface2);
  /* M3/Elevation Light/2 */
  border-radius: 4px;
}

option:hover,
select:focus > option:checked {
  background: var(--m3--read-only--light--primary--opacity-012) !important;
  background-color: var(
    --m3--read-only--light--primary--opacity-012
  ) !important;
}
</style>


<script>
import pageHeader from "./Components/Thema4PageHeader.vue";
import "vue3-carousel/dist/carousel.css";
import CountryFlag from "vue-country-flag-next";

import WordHighlighter from "vue-word-highlighter";
import moment from "moment";
import ForieLoader from "../shared/ForieLoader.vue";
import TeLoader from "../shared/TeLoader.vue";
import { mapState } from "vuex";
import Lightgallery from "lightgallery/vue";
import lgZoom from "lightgallery/plugins/zoom";
import lgVideo from "lightgallery/plugins/video";
export default {
  computed: mapState({
    isSearchChangedX: (state) => state.isSearchChangedX,
  }),
  watch: {
    isSearchChangedX(newVal) {
      if (newVal == true) {
        this.searchText = this.$store.state.searchInputValueX;
        this.getCompaniesList(0);
      }
    },
  },
  components: {
    WordHighlighter,

    ForieLoader,
    TeLoader,
    pageHeader,
    CountryFlag,
    Lightgallery,
  },
  data() {
    return {
      selectedMatchingCondition: 3,
      plugins: [lgZoom, lgVideo],
      companiesMembershipDetails: [],
      listedCompaniesIdList: [],
      showFilters: false,
      showLoader: true,
      showMoreLoader: true,
      countriesFullData: [],
      businessSegmentsFullData: [],
      mainCategoriesFullData: [],
      subCategoriesFullData: [],
      selectedMainAndSubCategories: [],
      companiesListData: [],
      noMoreCompanies: false,
      vipMembershipList: [],
      selectedSegments: [],
      selectedCountries: [],
      selectedCompanies: [],
      selectedCategories: [],
      membershipType: 0,
      keywords: [],
      activation: 0,
      currentPage: 0,
      skipValueCompanies: 0,
      searchText: "",
      hasFilterItems: false,
      selectedMainCategory: 0,
      selectedSubCategory: 0,
      selectedBusinessSegment: 0,
      selectedCountry: 0,
      mainCategories: [],
      subCategories: [],
      businessSegments: [],
      countries: [],
      hasCategory: false,
      hasKeywords: false,
      hasSegments: false,
      hasCountry: false,
      sortBy: 1,
    };
  },
  methods: {
    onInit: () => {
      console.log("lightGallery has been initialized");
    },
    onBeforeSlide: () => {
      console.log("calling before slide");
    },
    setInvalidImage(event) {
      event.target.src = this.$store.state.defaultLogoX;
    },

    setSortByValue(value) {
      this.sortBy = parseInt(value);
      this.getCompaniesList(0);
    },
    async getMainCategories() {
      var temp = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getMainCategories`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (temp = data))
        .catch((err) => console.log(err.message));

      this.mainCategoriesFullData = temp;

      temp.forEach((element) => {
        var mainCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;
        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.mainCategoryId == mainCategoryId
            ).length > 0
          ) {
            this.mainCategories.push({
              text: name,
              id: mainCategoryId,
            });
          }
        } else {
          this.mainCategories.push({
            text: name,
            id: mainCategoryId,
          });
        }
      });
    },
    setSelectedSearchCondition(id) {
      this.selectedMatchingCondition = parseInt(id);
      if (this.searchText.trim() != "") {
        this.getCompaniesList(0);
      }
    },
    setSelectedMainCategory(id) {
      this.selectedMainCategory = parseInt(id);
      this.subCategories = [];
      this.getSubCategories();
    },
    async getSubCategories() {
      if (this.selectedMainCategory == 0) {
        this.subCategories = [];
        return;
      }
      var mainIdList = [];
      mainIdList.push(this.selectedMainCategory);
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getSubCategories`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            categoryIdList: mainIdList,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.subCategories = data))
        .catch((err) => console.log(err.message));

      this.subCategoriesFullData = this.subCategories;
      var tempList = [];
      this.subCategories.forEach((element) => {
        var subCategoryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;

        if (this.selectedMainAndSubCategories.length > 0) {
          if (
            this.selectedMainAndSubCategories.filter(
              (q) => q.categoryId == subCategoryId
            ).length > 0
          ) {
            tempList.push({
              text: name,
              id: subCategoryId,
            });
          }
        } else {
          tempList.push({
            text: name,
            id: subCategoryId,
          });
        }
      });
      this.subCategories = [];
      this.subCategories = tempList;
    },
    setSelectedSubCategory(id) {
      this.selectedSubCategory = parseInt(id);
    },
    async getCountries() {
      var tempList = [];

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCountries`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (tempList = data))
        .catch((err) => console.log(err.message));

      this.countriesFullData = tempList;

      tempList.forEach((element) => {
        var countryId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        if (this.selectedCountries.length > 0) {
          if (this.selectedCountries.indexOf(countryId) !== -1) {
            this.countries.push({
              text: name,
              id: parseInt(element._id),
              flag: element.Flag,
            });
          }
        } else {
          this.countries.push({
            text: name,
            id: parseInt(element._id),
            flag: element.Flag,
          });
        }
      });
    },
    setSelectedCountry(id) {
      this.selectedCountry = parseInt(id);
    },
    async getCompaniesList(page) {
      if (page > 0) {
        this.showMoreLoader = true;
      } else {
        this.showLoader = true;
      }

      this.currentPage = page;
      if (this.currentPage == 0) {
        this.companiesListData = [];
        this.skipValueCompanies = 0;
      } else {
        this.skipValueCompanies = this.currentPage * 20;
      }

      if (this.searchText != "") {
        this.$store.state.searchInputValueX = this.searchText;
      } else {
        this.$store.state.searchInputValueX = "";
      }

      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/testCompaniesSearchIndex`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            domainSystem: this.$store.state.domainSystemX,
            activation: this.activation,
            keywords: this.keywords.length == 0 ? null : this.keywords,
            membershipType: this.membershipType,
            selectedCategories:
              this.selectedSubCategory > 0
                ? [this.selectedSubCategory]
                : this.selectedCategories.length == 0
                ? null
                : this.selectedCategories,
            selectedMainCategories:
              this.selectedMainCategory > 0
                ? [this.selectedMainCategory]
                : null,
            selectedCompanies:
              this.selectedCompanies.length == 0
                ? null
                : this.selectedCompanies,
            selectedCountries:
              this.selectedCountry > 0
                ? [this.selectedCountry]
                : this.selectedCountries.length == 0
                ? null
                : this.selectedCountries,
            selectedSegments:
              this.selectedBusinessSegment > 0
                ? [this.selectedBusinessSegment]
                : this.selectedSegments.length == 0
                ? null
                : this.selectedSegments,
            vipMembershipList:
              this.vipMembershipList.length == 0
                ? null
                : this.vipMembershipList,
            search: this.$store.state.searchInputValueX,
            page: this.skipValueCompanies,
            sortBy: this.sortBy,
            forProducts: true,
            matchingCase: this.selectedMatchingCondition,
            langCode: this.$store.state.langCodeX,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.companiesList = data))
        .catch((err) => console.log(err.message));

      if (this.companiesList.length < 20) {
        this.noMoreCompanies = true;
      } else {
        this.noMoreCompanies = false;
      }

      this.listedCompaniesIdList = [];
      this.companiesList.forEach((element) => {
        var companyName = element.Title;
        const dateObject = new Date(element.CreateTime);

        var companyUrlName = `${companyName
          .toLowerCase()
          .trim()
          .split(" ")
          .join("-")}`;

        companyUrlName = companyUrlName.replace(/[^a-zA-Z0-9,-]/g, "");
        companyUrlName = companyUrlName.replace(/---/g, "-");
        companyUrlName = companyUrlName.replace(/--/g, "-");

        var endDate = moment(new Date(), "YYYY");
        var createTime = moment(String(dateObject)).format("YYYY");

        var diff = endDate.diff(createTime, "years");
        var years = "";
        if (diff != undefined && !isNaN(diff) && diff > 0) {
          years = diff;
        }

        var companyId = parseInt(element.SecondaryId);
        this.listedCompaniesIdList.push(companyId);

        var isVip = element.IsVip;
        var countryName =
          element.Country.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length == 0
            ? element.Country.filter((q) => q.LangCode == "en").length == 0
              ? element.Country.filter(
                  (q) => q.LangCode != this.$store.state.langCodeX
                )[0].Name
              : element.Country.filter((q) => q.LangCode == "en")[0].Name
            : element.Country.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name;
        var countryCode =
          element.Country[0] != null && element.Country[0] != undefined
            ? element.Country[0].Icon
            : "";
        var logo =
          element.Logo == null
            ? this.$store.state.defaultLogoX
            : `https://cdn.turkishexporter.com.tr${element.Logo}`;

        logo = logo.toLowerCase();
        if (
          logo.indexOf(`companies/logo/1`) != -1 ||
          logo.indexOf(`companies/logo/logo`) != -1
        ) {
          logo = this.$store.state.defaultLogoX;
        }

        var companyDescription =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].DescriptionContent
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].DescriptionContent;
        companyDescription =
          companyDescription == null
            ? ""
            : companyDescription.length > 110
            ? `${companyDescription.substr(0, 110)}...`
            : companyDescription;

        var companyKeywords =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Keywords
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Keywords;
        companyKeywords =
          companyKeywords != null
            ? companyKeywords.length == 0
              ? ""
              : companyKeywords.split(",")
            : "";
        var link = element.LinkString;

        var companyProducts = [];

        element.Products.forEach((product) => {
          if (product.Images.length > 0) {
            var image =
              product.Images.length == 0 ? "" : product.Images[0].Image;
            var id = parseInt(product.Images[0]._id);
            if (image != "" && image != undefined) {
              var title =
                product.Localizations.length == 0
                  ? ""
                  : product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    ).length > 0
                  ? product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    )[0].Name
                  : product.Localizations.filter(
                      (q) => q.LangCode != this.$store.state.langCodeX
                    )[0].Name;

              var fullTitle = title;
              title = title.length > 10 ? `${title.substr(0, 10)}...` : title;

              var description =
                product.Localizations.length == 0
                  ? ""
                  : product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    ).length > 0
                  ? product.Localizations.filter(
                      (q) => q.LangCode == this.$store.state.langCodeX
                    )[0].Description
                  : product.Localizations.filter(
                      (q) => q.LangCode != this.$store.state.langCodeX
                    )[0].Description;

              var productLink = `${fullTitle
                .toLowerCase()
                .trim()
                .split(" ")
                .join("-")}-${id}`;

              productLink = productLink.replace(/[^a-zA-Z0-9,-]/g, "");
              productLink = productLink.replace(/---/g, "-");
              productLink = productLink.replace(/--/g, "-");

              companyProducts.push({
                productLink: productLink,
                companyUrlName: companyUrlName,
                countryName: countryName,
                companyId: companyId,
                image: image,
                title: title,
                fullTitle: fullTitle,
                description: description,
              });
            }
          }
        });

        this.companiesListData.push({
          id: companyId,
          link: link,
          name: companyName,
          createTime: createTime,
          years: years,
          isVip: isVip,
          countryName: countryName,
          countryCode: countryCode == null ? "" : countryCode.toLowerCase(),
          logo: logo,
          description: companyDescription,
          keywords: companyKeywords,
          products: companyProducts,
        });
      });
      this.$store.state.isSearchChangedX = false;
      this.showLoader = false;
      this.showMoreLoader = false;
      this.getCompaniesMembershipDetails();
    },
    async getCompaniesMembershipDetails() {
      var result = [];
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getCompaniesMembershipDetails`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            companies: this.listedCompaniesIdList,
            count: 20,
          }),
        }
      )
        .then((res) => res.json())
        .then((data) => (result = data))
        .catch((err) => console.log(err.message));

      result.forEach((element) => {
        var companyId = parseInt(element._id);
        var membershipName =
          element.CompanyActiveMembership.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.CompanyActiveMembership.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.CompanyActiveMembership.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name;
        var membershipLogo = element.CompanyActiveMembership.Icon;

        this.companiesMembershipDetails.push({
          companyId: companyId,
          name: membershipName,
          logo: membershipLogo,
        });
      });
    },
    async getBusinessSegments() {
      await fetch(
        `https://data.mongodb-api.com/app/forienetwork_app-qolvc/endpoint/getBusinessSegments`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
        .then((res) => res.json())
        .then((data) => (this.businessSegments = data))
        .catch((err) => console.log(err.message));

      var tempList = [];
      this.businessSegmentsFullData = this.businessSegments;

      this.businessSegments.forEach((element) => {
        var segmentId = parseInt(element._id);
        var name =
          element.Localizations.filter(
            (q) => q.LangCode == this.$store.state.langCodeX
          ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode == this.$store.state.langCodeX
              )[0].Name
            : element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              ).length > 0
            ? element.Localizations.filter(
                (q) => q.LangCode != this.$store.state.langCodeX
              )[0].Name
            : element.TagName;

        if (this.selectedSegments.length > 0) {
          if (this.selectedSegments.indexOf(segmentId) !== -1) {
            tempList.push({
              label: name,
              value: segmentId,
            });
          }
        } else {
          tempList.push({
            label: name,
            value: segmentId,
          });
        }
      });
      this.businessSegments = [];
      this.businessSegments = tempList;
    },
    setSelectedBusinessSegment(id) {
      this.selectedBusinessSegment = parseInt(id);
    },
    clearFilters() {
      this.selectedMainCategory = 0;
      this.selectedSubCategory = 0;
      this.searchText = "";
      this.selectedBusinessSegment = 0;
      this.selectedCountry = 0;
      this.$store.state.searchInputValueX = "";
      this.sortBy = 1;
      this.getCompaniesList(0);
    },
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
  },
  mounted() {
    if (this.$store.state.searchInputValueX != "") {
      this.searchText = this.$store.state.searchInputValueX;
    }
    // #region Left Side Filter
    this.hasFilterItems =
      this.$store.state.domainContentX.FilterContent.filter(
        (q) => q.id == "3" && parseInt(q.status) == 1
      ).length > 0
        ? true
        : false;

    if (this.hasFilterItems == true) {
      var filterItems = this.$store.state.domainContentX.FilterContent.filter(
        (q) => q.id == "3" && parseInt(q.status) == 1
      )[0].items;

      this.hasCategory =
        filterItems.filter((q) => parseInt(q.id) == 1 && q.status == 1).length >
        0;
      this.hasSegments =
        filterItems.filter((q) => parseInt(q.id) == 2 && q.status == 1).length >
        0;
      this.hasKeywords =
        filterItems.filter((q) => parseInt(q.id) == 3 && q.status == 1).length >
        0;

      this.hasCountry =
        filterItems.filter((q) => parseInt(q.id) == 4 && q.status == 1).length >
        0;

      if (
        this.hasCategory == false &&
        this.hasKeywords == false &&
        this.hasSegments == false &&
        this.hasCountry == false
      ) {
        this.hasFilterItems = false;
      }

      if (this.hasCategory) {
        this.getMainCategories();
      }

      if (this.hasSegments) {
        this.getBusinessSegments();
      }

      if (this.hasCountry) {
        this.getCountries();
      }
    }
    // #endregion

    // #region CompaniesFilter
    var companyContentX = this.$store.state.domainContentX.CompanyContent;
    this.activation = parseInt(companyContentX.Activation);
    var keywords = companyContentX.Keywords;
    this.membershipType = parseInt(companyContentX.MembershipType);
    var selectedCategories = companyContentX.SelectedCategories;
    var selectedCompanies = companyContentX.SelectedCompanies;
    var selectedCountries = companyContentX.SelectedCountries;
    var selectedSegments = companyContentX.SelectedSegments;
    var vipMembershipList = companyContentX.VipMembershipList;

    if (keywords.length > 0) {
      this.keywords = [];
      keywords.forEach((element) => {
        var text = element.text;
        this.keywords.push(text);
      });
    }

    if (selectedCompanies.length > 0) {
      this.selectedCompanies = [];
      selectedCompanies.forEach((element) => {
        var companyId = parseInt(element.id);
        this.selectedCompanies.push(companyId);
      });
    }

    if (selectedCategories.length > 0) {
      this.selectedCategories = [];
      selectedCategories.forEach((element) => {
        var categoryId = parseInt(element.categoryId);
        var mainCategoryId = parseInt(element.mainCategoryId);

        this.selectedCategories.push(categoryId);
        this.selectedMainAndSubCategories.push({
          mainCategoryId: mainCategoryId,
          categoryId: categoryId,
        });
      });
    }

    if (selectedCountries.length > 0) {
      this.selectedCountries = [];
      selectedCountries.forEach((element) => {
        var countryId = parseInt(element);
        this.selectedCountries.push(countryId);
      });
    }

    if (selectedSegments.length > 0) {
      this.selectedSegments = [];
      selectedSegments.forEach((element) => {
        var segmentId = parseInt(element);
        this.selectedSegments.push(segmentId);
      });
    }

    if (vipMembershipList.length > 0) {
      this.vipMembershipList = [];
      vipMembershipList.forEach((element) => {
        var membershipId = parseInt(element);
        this.vipMembershipList.push(membershipId);
      });
    }
    // #endregion

    this.getCompaniesList(0);
  },
};
</script>


<style>
.carousel {
  margin-bottom: 21px;
  margin-top: 21px;
}
.carousel__item {
  min-height: 200px;
  width: 100%;
  background-color: var(--m3--sys--light--background);
  color: rgb(0, 0, 0);
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  margin-right: 10px;
  border: 1px solid var(--m3--read-only--light--outline--opacity-008);
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
}
.carousel__item small {
  display: flex;
  white-space: pre;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  padding-top: 16px;
  padding-left: 16px;
  padding-bottom: 16px;
  color: var(--m3--sys--light--on-surface);
}
.carousel__item img {
  width: 130px;
  height: 130px;
}

.more-svg {
  background: transparent !important;
}
.more-svg svg {
  width: 70px !important;
}

.c-loader {
  background: transparent !important;
}

.company-keywords {
  flex-wrap: wrap;
}

.company-keywords > span {
  background: #fff;
  border: 1px solid var(--m3--read-only--light--outline--opacity-016);
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 6px 16px;
  margin-right: 8px;
  justify-content: center;
  margin-bottom: 8px;
  min-height: 30px;
  font-size: 11px;
}
</style>

<style lang="css">
@import url("https://cdn.jsdelivr.net/npm/lightgallery@2.0.0-beta.4/css/lightgallery.css");
@import url("https://cdn.jsdelivr.net/npm/lightgallery@2.0.0-beta.4/css/lg-zoom.css");
@import url("https://cdn.jsdelivr.net/npm/lightgallery@2.0.0-beta.4/css/lg-video.css");
</style>